export default __webpack_public_path__ + "static/media/Surface-Treatment-Vendors.e9857ec8.jpg";